module.exports = __webpack_public_path__ + "static/media/fiora.e40a330f.png";